import { ActivityItem } from '@cube3/cubicle/src/core/molecules/Activity/ActivityItem';
import React from 'react';
import { useProjectActivityFeed } from '../hooks/useProjectActivityFeed';

export const ProjectActivityItem = (props) => {
  const { activity, onClose } = props;

  const { imageSection, topRowSection, bottomRowSection } =
    useProjectActivityFeed(activity, onClose);

  return (
    <ActivityItem
      fullWidth={true}
      imageSection={imageSection}
      topRowSection={topRowSection}
      bottomRowSection={bottomRowSection}
    />
  );
};
